import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const SE_AI = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Software- Nature of Software, Introduction to Software Engineering,
        Software Engineering Layers, Software Myths, The Software Processes, Project, Product,
        Process Models: A Generic Process Model, Waterfall Model, Incremental Process Models,
        Evolutionary Process Models, Spiral Model. COCOMO Model. UML diagrams -Sequential,
        Class Diagram, Activity Diagram, Component Diagram, Use-Case Diagram, State Machine
        Diagram.</p>
    </div>,
    <div key="2" className="p-4">
      <p>
        Requirements Engineering- Functional and Non-Functional Requirements, The Software
        Requirements Document, Requirements Specification, Requirements Engineering,
        Requirements Elicitation and Analysis, Requirement Validation, Requirement Management,
        DFD, Data Dictionary. Introduction to ER diagrams. </p>
    </div>,
    <div key="3" className="p-4">
      <p>Software Design- Design concepts and principles - Abstraction - Refinement - Modularity
        Cohesion coupling, Architectural design, Detailed Design Transaction Transformation,
        Refactoring of designs, Object-oriented Design User-Interface Design. Software Testing:
        White-Box Testing, Black Box Testing. Stress Testing. Alpha, Beta, and Acceptance
        Testing. Debugging. </p>
    </div>,
    <div key="4" className="p-4">
      <p>Software Maintenance and Management- Software Maintenance, Types of Maintenance,
        Software Configuration Management, Overview of RE-engineering Reverse Engineering,
        Reliability: Failure and Faults, Reliability Models. Quality and Risk Management: Product
        Metrics, Software Measurements, Metrics for Software Quality, Risk Management: Software
        Risks, Risk Identification, Risk Projection, Risk Refinements, Risk Mitigation Monitoring
        and Management (RMMM). Overview Of Quality Management. CMM, ISO 9000, and Six
        Sigma. </p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Software Engineering"
      subjectKey="AI_SE"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AI_SENotes',
        videos: 'AI_SEVideos'
      }}
    />
  );
};

export default SE_AI;